import React, { useEffect } from 'react';
import Login from './pages/Login'
import PortalMenu from './pages/PortalMenu'
import { Route, Switch, useHistory, useLocation } from "react-router-dom";
import { getLogout } from './api/helpline/account';
import { getSession, isLoggedIn } from './User'
import Cookies from 'js-cookie'
import NotFound from './pages/NotFound';
import Auth from './Auth'
import { useDispatch, useGlobalState } from './provider/Provider'

interface Form {
  userId: string,
  password: string,
}
interface Notification {
  open: boolean,
  level: "success" | "info" | "warning" | "error" | undefined,
  message: string,
}

const ROOTPATH = process.env.REACT_APP_ROOT_PATH! || ''

const App: React.FC = () => {
  const dispatch = useDispatch()
  const globalbpState = useGlobalState('page')
  const globalqalistState = useGlobalState('qalist')
  const globalState = useGlobalState('user')
  const globalconlistState = useGlobalState('contractlist')
  const history = useHistory()
  const { from } = useLocation<{ from: string | undefined }>().state || ROOTPATH
  const { userId, token, role } = globalState
  const [form, setForm] = React.useState<Form>({
    userId: '',
    password: '',
  })

  const [notification, setNotification] = React.useState<Notification>({
    open: false,
    level: undefined,
    message: ''
  })

  const logIn = (token: string, role: string, ssflg: string) => {
    let sessionObj = {
      userId: form.userId,
      token: token,
      role: role,
      ssFlg: ssflg,
    }
    sessionStorage.clear();
    Cookies.set('SESSION', btoa(JSON.stringify(sessionObj)));
    dispatch({
      type: 'SET_USER',
      payload: {
        userId: form.userId,
        token: token,
        role: role,
        ssFlg: ssflg,
      },
      page: globalbpState,
      qalist: globalqalistState,
      contractlist: globalconlistState,
    })
    history.replace(from ?? ROOTPATH)
  }

  const logOut = () => {
    if (userId && token && role) {
      sessionStorage.clear()
      getLogout(userId, token, role).then(res => {
        if (res) {
          setForm({
            userId: '',
            password: '',
          })
          Cookies.remove('SESSION');
          dispatch({
            type: 'SET_USER',
            payload: {
              userId: '',
              token: '',
              role: '',
              ssFlg: '',
            },
            page: globalbpState,
            qalist: globalqalistState,
            contractlist: globalconlistState,
          })
          dispatch({
            type: 'SET_QALIST',
            payload: globalState,
            page: globalbpState,
            qalist: [],
            contractlist: globalconlistState,
          })
          history.push(`${ROOTPATH}/login`)
        }
      }).catch(err => handleError(err))
    }

  }

  const handleChangeForm = (event: React.ChangeEvent<{ value: unknown; name?: string | undefined }>) => {
    setForm({
      ...form,
      [event.target.name as string]: event.target.value as string
    })
  }
  const handleError = (err: any) => {
    let status = err.status
    //err is Response or Error apiFunction Error catch is Error(Error is Not param 'status'). apiFunction status is Not OK Response
    if (status) {//Resonse object
      if (status === 401) {
        setForm({
          userId: '',
          password: '',
        })
        Cookies.remove('SESSION');
        dispatch({ type: 'SET_USER', payload: { userId: '', token: '', role: '', ssFlg: '', }, page: { backpage: false }, qalist: [], contractlist: [], })
        dispatch({ type: 'SET_PAGE', payload: { userId: '', token: '', role: '', ssFlg: '', }, page: { backpage: false }, qalist: [], contractlist: [], })
        dispatch({ type: 'SET_QALIST', payload: { userId: '', token: '', role: '', ssFlg: '', }, page: { backpage: false }, qalist: [], contractlist: [], })
        dispatch({ type: 'SET_CONLIST', payload: { userId: '', token: '', role: '', ssFlg: '', }, page: { backpage: false }, qalist: [], contractlist: [], })
        history.push(`${ROOTPATH}/login`)
      } else {
        handleNotificationOpen('error', err.statusText)
      }
    } else {//Error object
      handleNotificationOpen('error', err.message)
    }
  }
  const handleNotificationClose = (event?: React.SyntheticEvent, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setNotification({
      ...notification,
      open: false,
    });
  };

  const handleNotificationOpen = (level: "success" | "info" | "warning" | "error", message: string) => {
    setNotification({
      ...notification,
      open: true,
      level: level,
      message: message,
    })
  }

  useEffect(() => {
    if (isLoggedIn()) {
      let [suserId, stoken, role, ssFlg] = getSession()
      if (suserId && stoken && role && ssFlg) {
        dispatch({
          type: 'SET_USER',
          payload: { userId: suserId, token: stoken, role: role, ssFlg: ssFlg, },
          page: { backpage: false },
          qalist: [],
          contractlist: [],
        })
      } else {
        dispatch({
          type: 'SET_USER',
          payload: { userId: '', token: '', role: '', ssFlg: '', },
          page: globalbpState,
          qalist: globalqalistState,
          contractlist: [],
        })
        dispatch({
          type: 'SET_PAGE',
          payload: { userId: '', token: '', role: '', ssFlg: '', },
          page: { backpage: false },
          qalist: globalqalistState,
          contractlist: [],
        })
        dispatch({
          type: 'SET_QALIST',
          payload: { userId: '', token: '', role: '', ssFlg: '', },
          page: globalbpState,
          qalist: [],
          contractlist: [],
        })
        dispatch({
          type: 'SET_CONLIST',
          payload: { userId: '', token: '', role: '', ssFlg: '', },
          page: globalbpState,
          qalist: [],
          contractlist: [],
        })
        Cookies.remove('SESSION');
      }
    }
  }, [])


  return (
    <div>
      <Switch>
        <Route exact path={`${ROOTPATH}/login`}>
          <Login
            form={form} handleChangeForm={handleChangeForm}
            logIn={logIn} handleError={handleError} handleNotificationClose={handleNotificationClose} notification={notification} handleNotificationOpen={handleNotificationOpen}
          />
        </Route>
        <Auth>
          <Switch>
            <Route path={ROOTPATH} >
              <PortalMenu
                logOut={logOut} notification={notification}
                handleError={handleError} handleNotificationClose={handleNotificationClose}
                handleNotificationOpen={handleNotificationOpen}
              />
            </Route>
          </Switch>
        </Auth>
        <Route component={NotFound} />
      </Switch>
    </div>
  );
}

export default App;
